import React from 'react'
import { HashRouter, Route, Switch } from 'react-router-dom'
import '@coreui/icons/css/coreui-icons.min.css'
import 'flag-icon-css/css/flag-icon.min.css'
import '@fortawesome/fontawesome-free/css/fontawesome.min.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import 'simple-line-icons/css/simple-line-icons.css'
import 'sweetalert2/dist/sweetalert2.min.css'
import './scss/style.css'
import './App.css'
import { DefaultLayout } from './containers'
import Page404 from './views/Pages/Page404/Page404'
import Page500 from './views/Pages/Page500/Page500'

const App = () => {
  return (
    <HashRouter>
      <Switch>
        <Route exact path="/404" name="Page 404" component={Page404} />
        <Route exact path="/500" name="Page 500" component={Page500} />
        <Route path="/" name="Home" component={DefaultLayout} />
      </Switch>
    </HashRouter>
  )
}

//App.contextType = CustomContext

export default App
App.displayName = 'App'
